import React from 'react';
import { Toast } from 'react-bootstrap';

function ToastNotify({ showToast, setShowToast, data }) {
  const closeToast = () => setShowToast(false);

  return (
    <div
      style={{
        position: 'absolute',
        bottom: '60px',
        left: '60px',
        zIndex: '999',
        borderRadius: '8px',
      }}
    >
      <Toast
        show={showToast}
        onClose={closeToast}
        style={{
          width: 'min(80vw, 450px)',
          background: 'white',
          boxShadow: '5px 5px 8px 2px #0000001f',
        }}
        delay={5000}
        autohide
      >
        <Toast.Header
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            color: 'white',
            background: '#e1ffe2',
          }}
        >
          {/* <img src="holder.js/20x20?text=%20" className="rounded me-2" alt="" /> */}
          <span>
            <strong className="me-auto">Notification </strong>
            {'  '}
            <small style={{ margin: '12px' }}>Just now</small>
          </span>
        </Toast.Header>
        <Toast.Body>
          {data.type === 'assign'
            ? `You are assigned to ${data.projectName}`
            : data.type === 'accept'
            ? `Congratulations, Your submission to ${data.projectName} has been approved`
            : data.type === 'reject'
            ? `Your submission to ${data.projectName} has been rejected`
            : `${data.commentator_name} commented on ${data.projectName}`}
        </Toast.Body>
      </Toast>
    </div>
  );
}

export default ToastNotify;
